import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import AutoLinkAccount from "./AutoLinkAccount";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import Divider from "@material-ui/core/Divider";
import {getUserAccounts} from "../../../requests/UserRequests";
import {trimLeadingZeroes} from "../../../utils";
import {Link, useHistory} from "react-router-dom";
import {Footer} from "../../footer/Footer";
import SimpleHeader from "../../header/SimpleHeader";
import BackToLogin from "../../BackToLogin";

function mapStateToProps(state) {
  return {};
}

function AutoRegisterPage(props) {
  let [accounts, setAccounts] = useState<any[]>([]);
  const history = useHistory();

  function updateAccounts() {
    getUserAccounts().then((response) => {
      setAccounts(response)
    });
  }

  useEffect(() => {
    updateAccounts();
  }, []);

  function createAccount(){
    history.push("/auto-register/create");
  }
  
  return (
    <React.Fragment>
      <SimpleHeader/>
      <div className={"container mt-5"}>
        <div className="row mt-4">
          <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 mx-auto">
            {accounts.length < 4 && <AutoLinkAccount onAccountAdded={updateAccounts}/>}
            {accounts.length >= 4 && <div className="card">
              <p>You have reached the max number of accounts.</p>
            </div>
            }
          </div>
          <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 mx-auto">
            <div className="card">
              <div className="row">
                <div className={"col-12"}>
                  <p><strong>Accounts</strong></p>
                  {accounts.length === 0 && <p>You have not added an account yet.</p>
                  }
                  <List>
                    {accounts.map(a => {
                      let partner = a.invoiceDetail.partner_data.find(_ => _.partner_function === "RG");
                      let address = partner.address_data;
                      return (<React.Fragment>
                        <ListItem>
                          <ListItemText primary={`${address.name} - ${trimLeadingZeroes(partner.partner_number)}`}/>
                        </ListItem>
                        <Divider/>
                      </React.Fragment>)
                    })}
                  </List>
                  {accounts.length === 0 ?
                    <button disabled={true} className={'btn btn-primary'}>Continue</button>
                    :
                    <button disabled={accounts.length === 0} className={"btn btn-primary"} onClick={createAccount}
                          >Continue</button>
                  }
                </div>
              </div>

            </div>
          </div>
        </div>
        <div className="row justify-content-center flex mt-3">
          <BackToLogin/>
        </div>
      </div>

      <Footer/>
    </React.Fragment>
  );
}

export default connect<any, any, any, any>((state, props) => {
  return {
    isLoggedIn: state.user.isLoggedIn,
  }
})(AutoRegisterPage);
